/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import "./style.less";

class PipelineSubsidyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
  }

  componentDidMount() {
    this.getProductData();
  }

  getProductData() {
    const itemList = this.props.config.itemList;
    const idList = itemList.map((item) => {
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    if (this.props.config.baseConfig.type === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    }

    axios({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const dataList = res.data.data.List;
        itemList.forEach((item) => {
          const itemData = dataList.find((dataItem) => dataItem.id === item.id);
          if (itemData) {
            Object.assign(item, itemData);
          }
        });
        this.setState({
          list: itemList,
        });
      }
    });
  }

  productClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;
    const options = {
      title: 1,
      name: item.title,
      sort: index
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    console.log(this.props);
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,-1,this.props);
  }

  handleViewMore = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    const options = {};
    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props);
  }

  render() {
    const { baseConfig, itemList } = this.props.config;
    const { componentDivideLine } = this.props
    const totalItemMargin = 6 * 2;
    return (
      <div className="pipeline-subsidyList" {...this.props['customAttributes']}>
        <img className="banner-img" src={utils.formatImgUrl(baseConfig.bannerImg, this.props.webpSupport)} />
        <div className="subsidy-container">
          <div className="more-btn" onClick={this.handleViewMore.bind(this, baseConfig.moreUrl)}></div>
          <img className="subsidy-img" src={utils.formatImgUrl(baseConfig.titleImg, this.props.webpSupport)} />
          <div className="subsidy-list">
            {this.state.list.map((item, index) => {
              // 计算折扣差价
              let discount = Number(item.original_price) - Number(item.price);
              discount = parseInt(discount);
              if (discount < 0 || isNaN(discount)) {
                discount = 0;
              }
              return (
                <div
                  key={index}
                  className="subsidy-item"
                  onClick={this.productClick.bind(this, item, index)}
                  style={{
                    width: `calc((100% - ${totalItemMargin}px) / 3)`,
                  }}
                >
                  <img className="product-img" src={utils.formatImgUrl(item.image, this.props.webpSupport)} />
                  {Boolean(discount) && (
                    <div 
                      className="price-tip"
                      style={{backgroundColor: baseConfig.discountBg, color: baseConfig.discountTextColor}}
                    >直降{discount}元</div>
                  )}
                  <div className="product-info">
                    <div className="name">{item.name || item.title}</div>
                    <div className="price" style={{color: baseConfig.priceColor, fontStyle: baseConfig.priceFontStyle}}>
                      <span className="rmb-icon">￥</span>
                      {item.price}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {this.props.notLastItem && componentDivideLine && (
          <img 
            className="component-divide-line" 
            src={utils.formatImgUrl(componentDivideLine, this.props.webpSupport)}
          />
        )}
      </div>
    );
  }
}

PipelineSubsidyList.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSubsidyList };
export default PipelineSubsidyList;



// WEBPACK FOOTER //
// ./components/pipeline-subsidyList/index.js